import { forwardRef } from 'react';
import { cn } from '../../lib/utils';

const Form = forwardRef<HTMLFormElement, React.FormHTMLAttributes<HTMLFormElement>>(
  ({ className, ...props }, ref) => (
    <form ref={ref} className={cn('space-y-6', className)} {...props} />
  )
);
Form.displayName = 'Form';

export { Form };
export { FormInput } from './FormInput'
export { FormField } from './FormField'
export { FormLabel } from './FormLabel'
export { FormSelect } from './FormSelect'
export { FormCheckbox } from './FormCheckbox'
export { FormTextarea } from './FormTextarea'